import { supabase } from '../../config/supabase';

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/crm`;

export async function crmFetch(path, options = {}) {
  const { data: { session } } = await supabase.auth.getSession();
  const res = await fetch(`${BASE}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session?.access_token || ''}`,
      ...(options.headers || {}),
    },
  });
  return res.json();
}
